import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import AppText from "../../components/Core/AppText/AppText";
import Button from "../../components/Core/Button/Button";
import TextArea from "../../components/Core/TextArea/TextArea";
import Flex from "../../components/Layout/Flex";
import useUnsavedChangesInFormChecker from "../../hooks/useUnsavedChangesChecker";
import Consultant from "../../models/Consultant";
import { useUpdateCandidate } from "../../networking/candidate.hooks";

type PresentationForm = { message: string };

const RecruitmentPresentationTab: React.FC<{ candidate: Consultant }> = ({ candidate }) => {
	const { t } = useTranslation();

	const { mutate: updateCandidate, isLoading } = useUpdateCandidate();

	const { register, handleSubmit, formState, reset } = useForm<PresentationForm>({
		defaultValues: {
			message: candidate?.profile?.presentation || "",
		},
	});

	const onSubmit = handleSubmit(async (e) => {
		if (candidate?.id) {
			await updateCandidate({
				userId: candidate.id,
				update: {
					profile: {
						presentation: e.message,
					},
				},
			});
		}
	});

	useEffect(() => {
		reset({ message: candidate?.profile.presentation });
	}, [candidate, reset]);

	useUnsavedChangesInFormChecker(formState);

	return (
		<Styles>
			<form onSubmit={onSubmit}>
				<Flex width="627px" maxWidth="100%" direction="column">
					<AppText size="m" weight="bold" color="grayTextLight">
						{t("PUBLIC_PRESENTATION")}
					</AppText>

					<TextArea
						{...register("message")}
						width="100%"
						height="506px"
						errors={formState.errors.message?.message}
					/>

					<ButtonWrapper>
						<Button
							disabled={isLoading}
							width="150px"
							margin="2.9375rem 0 2.9375rem 0"
							fontSize="xms"
						>
							{t("SAVE_CHANGES")}
						</Button>
					</ButtonWrapper>
				</Flex>
			</form>
		</Styles>
	);
};

export default RecruitmentPresentationTab;

const Styles = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	margin-top: 1.7rem;
	flex-direction: column;
`;

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
